import React from 'react';
import {
  Modal,
  Box,
  Typography,
  Button
} from '@mui/material';
import { ReactComponent as Warning } from 'assets/Warning.svg'; 

const ExportToExcelModal = ({ open, onClose, onFilterData,onAllData }) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="ExportToExcelModal-warning"
      aria-describedby="ExportToExcelModal-description"
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          backgroundColor: 'white',
          borderRadius: '12px',
          padding: '40px 10px',
          maxWidth: '500px',
          width: '90%',
          textAlign: 'center',
          boxShadow: '0 10px 25px rgba(0, 0, 0, 0.2)',
          outline: 'none'
        }}
      >
        {/* Failed Icon */}
        
          <Box sx={{ mb: 0 }}>
          <Warning style={{ width: '161px', height: '149px', margin: '0 auto' }} />
        </Box>

        {/* Warning Message */}
        <Typography
          id="ExportToExcelModal-description"
          sx={{
            color: '#333',
            fontSize: '16px',
            lineHeight: 1.5,
            fontFamily:'Montserrat',
            fontWeight:500,
            mb: 4,
            maxWidth: '400px',
             margin: '0 auto'
          }}
        >
         Do you want to export All data or only the filtered data?
        </Typography>

        <Button
          onClick={onFilterData}
          sx={{
            mt:4,
            backgroundColor: '#102A62',
            color: 'white',
            borderRadius: '10px',
            padding: '10px 24px',
            fontSize: '16px',
            fontWeight: 600,
            minWidth: '100px',
            '&:hover': {
              backgroundColor: '#102A62'
            },
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
          }}
        >
          FILTERED DATA
        </Button>
         <Button
          onClick={onAllData}
          sx={{
            mt:4,
            ml:2,
            backgroundColor: '#102A62',
            color: 'white',
            borderRadius: '10px',
            padding: '10px 24px',
            fontSize: '16px',
            fontWeight: 600,
            minWidth: '100px',
            '&:hover': {
              backgroundColor: '#102A62'
            },
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
          }}
        >
          ALL DATA
        </Button>
      </Box>
    </Modal>
  );
};

export default ExportToExcelModal;
